import { Box, Flex, Heading, Text, Button, Image, Highlight } from '@chakra-ui/react';
import { Link } from 'react-router-dom'; // If using React Router
import { MdChat, MdPeople, MdFavorite } from 'react-icons/md';
import icon from "../icons/output-onlinegiftools.gif"
import { useRef } from 'react';
import love from "../assets/14112994-unscreen (1).gif"
// import love from "../assets/14113003.mp4"

import logo from "../icons/bondlogo.png"
const HomePage = () => {
  const videoRef = useRef(null);
  const pageStyle = {
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: "backgroundColor",
    color: '#fff', // Text color, adjust based on background
    fontFamily: 'Arial, sans-serif',
    textAlign: 'center',
    padding: '20px',
  };
  // background: linear-gradient(90deg, #fcff9e 0%, #c67700 100%);

  const handleVideoEnded = () => {
    // Reset the video playback to the beginning
    if (videoRef.current) {
      videoRef.current.currentTime = 0;
      videoRef.current.play();
    }
  };


  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      h="110vh"
      // bgGradient="linear-gradient(to left top, #d3d6bc, #87bb9d, #009da3, #0077b4, #0e45a3)"
      style={{ background: "linear-gradient(90deg, rgb(0 0 0) 0%, rgb(162 89 211) 100%)" }}
      color="white"
      px={8}

    >


      {/* background-image: linear-gradient(to top, #0c3483 0%, #a2b6df 100%, #6b8cce 100%, #a2b6df 100%); */}
      <Box maxW="xl" textAlign="center" pt="70px">
        <Box display={"flex"} justifyContent={"center"}>
          <Image src={logo} alt="Logo" w={333} mb={4} />

        </Box>
        <Heading as="h1" size="2xl" mb={4} color="white">
          Welcome to Bond Chat !
        </Heading>
        <Text fontSize="xl" mb={4} color="white" fontFamily={"'DM Sans Merlin'"} fontWeight={"700"}>
          Connect with AI mentors, parents, friends, and loved ones with <Highlight query='multiple language support. ' styles={{ px: '2', py: '1', rounded: 'full', bg: 'black' ,color:'white'}}>
          multiple language support.
        </Highlight>
      </Text>
      <br />

      <Flex justify="center" align={"center"} mb={4}>
        {/* <Button as={Link} to="/get-start-talk" color="black" size="lg" mr={4} border="2px solid black" leftIcon={<Icon as={MdChat} />}>
            Get Start
          </Button> */}
        <Button as={Link} to="/get-start-talk"
          style={{
            background: '#a370f0',
            color: 'black',
            fontFamily: 'inherit',
            padding: '0.35em',
            paddingLeft: '1.2em',
            fontSize: '17px',
            fontWeight: 500,
            borderRadius: '0.9em',
            border: 'none',
            letterSpacing: '0.05em',
            display: 'flex',
            alignItems: 'center',
            boxShadow: 'inset 0 0 1.6em -0.6em #714da6',
            overflow: 'hidden',
            position: 'relative',
            height: '2.8em',
            paddingRight: '3.3em',
            cursor: 'pointer',
          }}
        >
          Get started
          <div
            style={{
              background: 'white',
              marginLeft: '1em',
              position: 'absolute',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '2.2em',
              width: '2.2em',
              borderRadius: '0.7em',
              boxShadow: '0.1em 0.1em 0.6em 0.2em #7b52b9',
              right: '0.3em',
              transition: 'all 0.3s',
            }}
          >
            <svg
              style={{
                width: '1.1em',
                transition: 'transform 0.3s',
                color: '#7b52b9',
              }}
              height="24"
              width="24"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M0 0h24v24H0z" fill="none"></path>
              <path
                d="M16.172 11l-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2z"
                fill="currentColor"
              ></path>
            </svg>
          </div>
        </Button>

        {/* <Button as={Link} to="/signup" colorScheme="teal" size="lg" leftIcon={<Icon as={MdPeople} />}>
            Sign Up
          </Button> */}
      </Flex>
      <br />

      <br />
      <Text fontSize="sm" color="white" mb={4} style={{ fontSize: '18px', fontFamily: "'DM Sans Merlin'", fontWeight: 700 }}>
        💝
        Discover a place where you can chat, share, and connect with those who matter most to you.
      </Text>
      <Text fontSize="sm" color="white" mb={4} style={{ fontSize: '18px', fontFamily: "'DM Sans Merlin'", fontWeight: 700 }}>
        💖
        From now on, nobody leaves you - not mentors, parents, friends, or even loved ones.
      </Text>
      <Text fontSize="sm" color="white" style={{ fontSize: '18px', fontFamily: "'DM Sans Merlin'", fontWeight: 700 }}>
        💝
        Share moments, advice, and stories with your ChatBuddy network.
      </Text>

    </Box>
    </Flex >
  );
};

export default HomePage;
